import { Fragment } from 'react';
import ContentLoader from 'react-content-loader';

export const UpsellMediumLoader = (props: any) => (
  <ContentLoader
    data-test-id="pdp-card-loader"
    speed={2}
    width={250}
    height={431}
    viewBox="0 0 250 431"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="0" y="0" rx="12" ry="12" width="250" height="193" />
    <rect x="0" y="216" rx="3" ry="3" width="220" height="15" />
    <rect x="0" y="240" rx="3" ry="3" width="180" height="15" />
    <rect x="0" y="265" rx="3" ry="3" width="200" height="15" />
    <rect x="0" y="321" rx="3" ry="3" width="100" height="30" />
    <rect x="0" y="360" rx="3" ry="3" width="200" height="15" />
  </ContentLoader>
);

const PDPCardMobile = (props: any) => (
  <ContentLoader
    speed={2}
    width={320}
    height={220}
    viewBox="0 0 320 220"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="0" y="0" rx="5" ry="5" width="151" height="220" />
    <rect x="175" y="18" rx="5" ry="5" width="145" height="12" />
    <rect x="175" y="100" rx="5" ry="5" width="68" height="18" />
    <rect x="253" y="100" rx="5" ry="5" width="68" height="18" />
    <rect x="175" y="133" rx="5" ry="5" width="110" height="28" />
    <rect x="175" y="187" rx="5" ry="5" width="130" height="12" />
    <rect x="175" y="55" rx="5" ry="5" width="125" height="12" />
    <rect x="175" y="37" rx="5" ry="5" width="105" height="12" />
  </ContentLoader>
);

export const PDPCardLoader = (props: any) => (
  <Fragment>
    <UpsellMediumLoader className="hidden md:block" />
    <PDPCardMobile data-testid="pdp-card-loader" className="block md:hidden" />
  </Fragment>
);
